import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../Buttons/BtnSubmit';
import {showAppLoader, hideAppLoader} from '../../Loader/LoaderSlice';
import ProviderManager from '../../../../provider/providerManager';
import radioChecked from './images/radio-checked.svg';

const SubscribersSelection = (props) => {
    const [subscribers, setSubscribers] = useState([]);
    const [subscriber, setSubscriber] = useState(null);
    const [subscriberError, setSubscriberError] = useState('');

    useEffect(() => {
        async function getSubscribers() {
            let subscribers = [];
            try {
                props.showAppLoader();
                if (props.saleType !== undefined) {
                    const saleType = props.saleType;
                    const result = await ProviderManager.getProviderData('getSubscribers', [saleType]);
                    subscribers = result?.Body?.subscribers;
                } else {
                    if (props.subscribers?.length > 1) {
                        subscribers = props.subscribers
                    }
                }
            } catch (error) {
                if (error.toString().includes('401')) {
                    return;
                }
                props.onSelectSubscriber(null);
            } finally {
                props.hideAppLoader();
            }

            if (subscribers.length > 0) {
                if (subscribers.length == 1) {
                    props.onSelectSubscriber(subscribers[0]);
                } else {
                    setSubscribers(subscribers);
                }
            } else {
                props.onSelectSubscriber(null);
            }
        }

        getSubscribers();
    }, []);

    if (!subscribers || subscribers.length == 0) {
        return null;
    }

    return (
        <div className='subscriber-selection-page'>

            <div
                className='page-title'>{props.saleType ? " ראינו שיש לך כמה מנויי אינטרנט" : "ראינו שיש לך כמה מנויים"}</div>
            <div className='page-sub-title'> עם איזה מנוי נמשיך?</div>

            <div className='subscriber-list-wrapper'>

                {
                    subscribers?.map((item, index) => {
                        return (
                            <div className='subscriber' key={index}>
                                <input type='radio' id={`radio-subscriber-${index}`} name='subscriber'
                                       onChange={() => handleOnSubscriberClick(item)}/>
                                <label htmlFor={`radio-subscriber-${index}`}>
                                    <div className='radio-icon' style={{backgroundImage:radioChecked.bg()}}></div>
                                    <div className='details'>
                                        <div className='service'> {item} </div>
                                        <div className='service'> {item?.productDescription} </div>
                                        <div className='address'> {item?.address?.fullAddress} </div>
                                    </div>
                                </label>
                            </div>
                        );
                    })
                }


                {subscriberError && <div className='error-not-selected'>{subscriberError}</div>}

            </div>

            <div className='button-wrapper'>
                <BtnSubmit
                    isBusiness={false}
                    text='המשך'
                    onclick={handleOnSelectSubscriber}
                    formid='subscriber-page'
                    isDisplayArrows={false}
                    isDisplayWhatsAppIcon={false}

                />
            </div>

        </div>
    );

    function handleOnSubscriberClick(item) {
        setSubscriber(item);
        setSubscriberError('');
    }

    function handleOnSelectSubscriber() {
        if (!subscriber) {
            setSubscriberError('אנא בחר מנוי');
            return;
        }
        props.onSelectSubscriber(subscriber);
    }

};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {
    showAppLoader,
    hideAppLoader
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscribersSelection);
